<template>
    <div class="wrap wrap--sub">
        <main-header></main-header>

        <main class="main" role="main">
            <!-- 서브 비주얼 -->
            <sub-visual :visual="visual"></sub-visual>

            <div class="inner">
                <div class="estimate-list-container">
                    <!-- 카테고리 -->
                    <estimate-inquery-categories-parents :categories="categories" @set-category-parent="setCategoryParent" />

                    <!-- 탭 -->
                    <ul class="tab-contents">
                        <li v-for="category in categories._parents" :key="category._id" :class="{ on: category._id === categories.selected._parent._id }">
                            <div class="table-list">
                                <p class="tl-caption align-right"><span class="color-red">*</span> 필수 입력 항목</p>
                                <div class="tl-section">
                                    <!-- 시공지 유형 -->
                                    <estimate-inquery-categories-children
                                        :input="input._category"
                                        :categories="categories._children.filter(({ _id }) => category._children.includes(_id))"
                                        @set-input="setInput"
                                    />

                                    <!-- 시공 면적 -->
                                    <div class="tl-row">
                                        <div class="tl-columnheader">
                                            <h2 class="tl-tit">시공 면적 <span class="color-red">*</span></h2>
                                        </div>
                                        <div class="tl-cell">
                                            <div class="form-text">
                                                <input type="number" class="input" placeholder="평수를 입력하세요." v-model="input.acreage" />
                                                <span class="ft-txt">평</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 시공 희망일 -->
                                    <estimate-inquery-target-date :input="input.targetDate" @set-input="setInput" />

                                    <!-- 시공 예산 -->
                                    <estimate-inquiry-budget @set-input="setInput" />

                                    <!-- 공사지 주소 -->
                                    <estimate-inquery-address :inputs="{ postcode: input.postcode, address1: input.address1, address2: input.address2 }" @set-input="setInput" />
                                </div>
                                <div class="tl-section">
                                    <!-- 성함 -->
                                    <div class="tl-row">
                                        <div class="tl-columnheader">
                                            <h2 class="tl-tit">성함 <span class="color-red">*</span></h2>
                                        </div>
                                        <div class="tl-cell">
                                            <input class="input" type="text" placeholder="성함을 입력하세요." v-model="input.name" />
                                        </div>
                                    </div>

                                    <!-- 연락처 -->
                                    <estimate-inquery-phone @set-input="setInput" />

                                    <!-- 요청사항 -->
                                    <div class="tl-row">
                                        <div class="tl-columnheader align-top">
                                            <h2 class="tl-tit">요청사항 <span class="color-red">*</span></h2>
                                        </div>
                                        <div class="tl-cell">
                                            <textarea placeholder="요청사항을 입력하세요." v-model="input.requests"></textarea>
                                        </div>
                                    </div>
                                </div>

                                <!-- 선택한 스타일 / 이미지 업로드 -->
                                <estimate-inquery-reference v-if="portfolio" :portfolio="portfolio" :_parents="categories._parents" @go-estimate="goEstimate" />
                                <estimate-inquiry-image v-else @set-input="setInput" />

                                <!-- 약관 동의 -->
                                <div class="tl-section">
                                    <div class="check-wrap">
                                        <label class="check control-block check-sm">
                                            <input type="checkbox" class="input" :checked="input._terms.length == terms.length" @click="selectAllTerms" />
                                            <i class="icon"></i><span class="text">전체 동의</span>
                                        </label>
                                        <label class="check control-block check-sm" v-for="(term, i) in terms" :key="i">
                                            <input type="checkbox" class="input" v-model="input._terms" :value="term._id" />
                                            <i class="icon"></i><span class="text">{{ term.subject }}에 동의 ({{ term.necessary ? "필수" : "선택" }})</span>
                                        </label>
                                    </div>
                                </div>

                                <!-- 버튼 -->
                                <div class="bottom-button">
                                    <button class="button button-lg button--border" @click="reset">취소</button>
                                    <button class="button button-lg button--primary" @click="submit">신청하기</button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </main>
        <main-footer></main-footer>
        <modal-portfolio-estimate ref="ModalPortfolioEstimate" :portfolio="portfolio" />
    </div>
</template>

<script>
import api from "@/api";
import MainHeader from "../../../components/client/inc/main-header.vue";
import MainFooter from "../../../components/client/inc/main-footer.vue";
import SubVisual from "../../../components/client/sub/sub-visual.vue";
import EstimateInqueryCategoriesParents from "@/components/client/estimate/estimate-inquiry-categories-parent.vue";
import EstimateInqueryCategoriesChildren from "@/components/client/estimate/estimate-inquiry-categories-children.vue";
import EstimateInqueryTargetDate from "@/components/client/estimate/estimate-inquiry-target-date.vue";
import EstimateInqueryAddress from "@/components/client/estimate/estimate-inquiry-address.vue";
import EstimateInqueryPhone from "@/components/client/estimate/estimate-inquiry-phone.vue";
import EstimateInqueryReference from "@/components/client/estimate/estimate-inquiry-reference.vue";
import ModalPortfolioEstimate from "@/components/client/portfolio/estimate/modal-portfolio-estimate.vue";
import EstimateInquiryBudget from "@/components/client/estimate/estimate-inquiry-budget.vue";
import EstimateInquiryImage from "@/components/client/estimate/estimate-inquiry-image.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        SubVisual,
        EstimateInqueryCategoriesParents,
        EstimateInqueryCategoriesChildren,
        EstimateInqueryTargetDate,
        EstimateInqueryAddress,
        EstimateInqueryPhone,
        EstimateInqueryReference,
        ModalPortfolioEstimate,
        EstimateInquiryBudget,
        EstimateInquiryImage,
    },
    data: () => {
        return {
            query: {
                _category: undefined,
                _portfolio: undefined,
            },
            visual: "estimate",
            portfolio: undefined,
            categories: {
                _parents: [],
                _children: [],
                selected: {
                    _parent: {},
                    _child: {},
                },
            },
            terms: [],
            input: {
                _user: undefined,
                _category: undefined, // 유형
                _terms: [],
                acreage: "", // 면적
                targetDate: "", // 희망일
                budget: "", // 예산
                postcode: "", // 우편번호
                address1: "", // 주소1
                address2: "", // 주소2
                geolocation: null,
                name: "", // 성함
                phone: "", // 연락처
                requests: "", // 요청사항
                _portfolio: undefined, // 선택한 스타일
                image: undefined,
                status: "견적신청",
            },
        };
    },
    mounted() {
        const { _category, _portfolio } = this.$route?.query;
        this.query = { _category, _portfolio };
        this.input = { ...this.input, _category, _portfolio, _user: this._user };
        this.init();
    },
    methods: {
        async init() {
            try {
                const { categories } = await api.v1.portfolios.categories.getCategories(),
                    _parents = categories.filter(({ _parents }) => !_parents.length),
                    _children = categories.filter(({ _parents }) => _parents.length),
                    _parent = _parents.find(({ _children }) => _children.includes(this.query._category)) || _parents[0],
                    _child = _children.find(({ _id }) => _id == (this.query._category || _parents[0]._children[0]));

                const { termsList } = await api.v1.terms.getTermsAll();
                this.terms = termsList;

                this.categories = {
                    selected: {
                        _parent,
                        _child,
                    },
                    _parents,
                    _children,
                };

                if (this.query._portfolio) {
                    const { portfolio } = await api.v1.portfolios.getPortfolio({ _id: this.query._portfolio });
                    this.portfolio = portfolio;
                }
            } catch (error) {
                console.error(error);
            }
        },
        setCategoryParent(_category) {
            this.categories.selected._parent = _category;
        },
        setInput(_input) {
            this.input = { ...this.input, ..._input };
        },
        goEstimate() {
            this.$refs.ModalPortfolioEstimate.modal = true;
        },
        selectAllTerms(event) {
            const isTrue = event?.target?.checked;
            if (isTrue) this.input._terms = this.terms.map(({ _id }) => _id);
            else this.input._terms = [];
        },
        checkInput() {
            if (!this.input._category) throw new Error("시공지 유형을 선택해주세요.");
            if (this.input.acreage.length < 1) throw new Error("시공 면적을 입력해주세요.");
            if (this.input.targetDate.length < 1) throw new Error("시공 희망일을 선택해주세요.");
            if (this.input.budget.length < 1) throw new Error("시공 예산을 선택해주세요.");
            // if (this.input.address1.length < 1) throw new Error("공사지 주소를 입력해주세요.");
            if (this.input.name.length < 1) throw new Error("성함을 입력해주세요.");
            if (this.input.phone.length < 10) throw new Error("연락처를 입력해주세요.");
            if (this.input.requests.length < 1) throw new Error("요청사항을 입력해주세요.");
            if (!this.input._portfolio && !this.input.image) throw new Error("원하는 스타일의 사진을 업로드해주세요.");
            if (this.input._terms.length !== this.terms.reduce((count, term) => (term.necessary ? count + 1 : count), 0)) throw new Error("필수 약관에 모두 동의하지 않으셨습니다.");

            return true;
        },
        reset() {
            this.input = {
                ...this.input,
                acreage: "", // 면적
                targetDate: "", // 희망일
                budget: "", // 예산
                postcode: "", // 우편번호
                address1: "", // 주소1
                address2: "", // 주소2
                coord: null,
                name: "", // 성함
                phone: "", // 연락처
                requests: "", // 요청사항
            };
        },
        async submit() {
            try {
                if (this.checkInput()) {
                    const { estimateInquiry } = await api.v1.portfolios.estimateInquiries.postEstimateInquiry(this.input);

                    if (this.input.image) await api.v1.portfolios.estimateInquiries.postImage(estimateInquiry, this.input.image);

                    alert("견적신청이 완료되었습니다.");
                    this.$router.push("/");
                }
            } catch (error) {
                console.log(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    computed: {
        _user() {
            return this.$store?.state?.payload?._user || undefined;
        },
    },
};
</script>
